import React, { useRef, useEffect, useState } from "react";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
const imgWidths = {
  profile: 750,
  story: 590,
  cover: 1275,
  slider: 1920,
};
const imgHeights = {
  profile: 750,
  story: 300,
  cover: 319,
  slider: 618,
};

const imgAspectRatios = {
  profile: 1,
  story: 590 / 300,
  cover: 1275 / 319,
  slider: 1920 / 618,
};

export default function ImageCropping({
  imageFile,
  onClose,
  onCrop,
  imageType,
  sectionName = ''
}) {
  const [cropper, setCropper] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const imageRef = useRef(null);

  const handleCrop = () => {
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: imgWidths[imageType] || 750,
        height: imgHeights[imageType] || 750,
      });

      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob],
            `${Math.random().toString(36).substr(2, 10) + '.' + getFileExtension(imageFile.name)}`,
            {
              type: blob.type,
            });
          if (sectionName == '')
            onCrop(file, imageType);
          else
            onCrop(file, imageType, sectionName);
        }
      }, imageFile.type);
    }
  };

  React.useEffect(() => {
    if (imageRef.current && imageFile) {

      const reader = new FileReader();
      reader.onload = (e) => {
        setImageSrc(e.target.result);
      };
      reader.readAsDataURL(imageFile);

    }
  }, [imageFile]);

  useEffect(() => {
    if (imageRef.current && imageSrc) {
      const cropperInstance = new Cropper(imageRef.current, {
        aspectRatio: imgAspectRatios[imageType] || 1,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
      });
      setCropper(cropperInstance);
      return () => {
        cropperInstance.destroy();
      };
    }
  }, [imageSrc]);

  const getFileExtension = (filename) => {
    const extension = filename.split('.').pop();
    return extension;
  }

  return (

    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Crop Image</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body d-flex" >
            <img
              ref={imageRef}
              src={imageSrc}
              alt="Picture to crop"
              style={{ height: "350px" }}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={handleCrop}>Crop</button>
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}
